export const TEAM_CHAT_CHANNEL_LIST_EMPTY_LABEL = 'No channels available';
